import { get, post, del } from '../utils/makeRequest';

const ADMIN_INVOICE_ENDPOINTS = {
  GET_ALL_INVOICES: '/admin/invoices',
  GET_INVOICE_DETAILS: '/admin/invoices',
  DOWNLOAD_INVOICE_PDF: '/admin/invoices',
  GENERATE_INVOICE: '/admin/invoices/generate',
  SEND_REMINDER: '/admin/invoices/send-reminder',
  DELETE_INVOICE: '/admin/invoices',
};

export const adminInvoiceService = {
  /**
   * Get all invoices for admin view
   * @returns {Promise} - List of all invoices
   */
  getAllInvoices: async () => {
    return get(ADMIN_INVOICE_ENDPOINTS.GET_ALL_INVOICES);
  },

  /**
   * Get detailed invoice information by ID
   * @param {number} invoiceId - The invoice ID
   * @returns {Promise} - Detailed invoice data
   */
  getInvoiceDetails: async (invoiceId) => {
    return get(`${ADMIN_INVOICE_ENDPOINTS.GET_INVOICE_DETAILS}/${invoiceId}`);
  },

  /**
   * Download invoice PDF from backend
   * @param {number} invoiceId - The invoice ID
   * @returns {Promise<Blob>} - PDF blob for download
   */
  downloadInvoicePDF: async (invoiceId) => {
    try {
      const token = localStorage.getItem('token');
      
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || '/api'}${ADMIN_INVOICE_ENDPOINTS.DOWNLOAD_INVOICE_PDF}/${invoiceId}/download`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download invoice');
      }

      return await response.blob();
    } catch (error) {
      console.error('Error downloading invoice:', error);
      throw error;
    }
  },

  /**
   * Generate a new invoice (if needed)
   * @param {object} invoiceData - Invoice data for generation
   * @returns {Promise} - Generated invoice details
   */
  generateInvoice: async (invoiceData) => {
    return post(ADMIN_INVOICE_ENDPOINTS.GENERATE_INVOICE, invoiceData);
  },

  /**
   * Send payment reminder for an invoice
   * @param {number} invoiceId - The invoice ID
   * @returns {Promise} - Reminder sent confirmation
   */
  sendReminder: async (invoiceId) => {
    return post(`${ADMIN_INVOICE_ENDPOINTS.SEND_REMINDER}/${invoiceId}`);
  },

  deleteInvoice: async (invoiceId) => {
    return del(`${ADMIN_INVOICE_ENDPOINTS.DELETE_INVOICE}/${invoiceId}`);
  },
};
